<!-- GaoKaoStep  高考步骤条组件  XIJIGUO -->
<template>
  <div>
    <div class="label" v-if="examType == ''">选择等级赋分类型</div>
    <div class="label" v-else-if="examType == '1'">3+1+2考试模式</div>
    <div class="label" v-else-if="examType == '4'">8档</div>
    <div class="label" v-else-if="examType == '3'">11档</div>
    <div class="label" v-else-if="['2', '5', '6'].indexOf(examType + '') > -1">21档</div>
    <div class="label" v-else-if="examType == '7'">3+大综合</div>
    <el-steps :active="active" align-center>
      <el-step v-for="(item, index) of stepList" :key="index" :title="item.title" :icon="stepIcon(index)" :class="stepClass(index)" @click.native="jumpPage(item, index)" />
    </el-steps>
  </div>
</template>
<script>
export default {
  name: 'GaoKaoStep',
  props: {
    active: {
      type: Number,
      default: 0
    },
    newFlag: {
      type: Boolean,
      default: false
    },
    examType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      stepList: [
        { title: '选择等级赋分', pathName: 'LevelType' },
        { title: '选择考试', pathName: 'ChooseExam' },
        { title: '等级设置', pathName: 'SetLevel' },
        { title: '完成' }
      ]
    }
  },
  methods: {
    stepIcon (index) {
      return index < this.active ? 'el-icon-success' : ''
    },
    stepClass (index) {
      return index < this.active ? 'el-success' : ''
    },
    jumpPage (item, index) {
      if (index >= this.active) {
        return
      }

      if (this.newFlag && item.pathName === 'ChooseExam') {
        item.pathName += 'New'
      }

      const query = index === 0 ? {} : this.$route.query
      this.$router.replace({ name: item.pathName, query: { ...query, isBack: true } })
    }
  }
}
</script>
<style scoped lang="scss">
.el-success {
  cursor: pointer;
}

.label {
  text-align: center;
  font-size: 20px;
  font-family: Source Han Sans SC;
  font-weight: bold;
  line-height: 29px;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
  margin-bottom: 10px;
}
</style>
